import { BOOKMARKS } from "icons";
import { NavItem } from "../../../components/nav/item";

export function BookmarksNavigations() {

  return (
    <NavItem
      title={
        <span className="flex justify-between">
          Bookmarks{" "}
        </span>
      }
          icon={BOOKMARKS}
      url="/bookmarks"
    />
  );
}
